// extracted by mini-css-extract-plugin
export default {"avatarWrap":"UserViewModal_avatarWrap__6W14q","avatar":"UserViewModal_avatar__EwimU"};